const Rights = (props) => {
    return(
        <>
            rights
        </>
    )
}

export default Rights